import React from "react";
import { css } from "emotion";
import { colors } from "../../styles/theme";

const MenuIcon = () => {
  return (
    <div className={icon}>
      <div className="top"></div>
      <div className="bottom"></div>
    </div>
  );
};

export default MenuIcon;

const icon = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 8px;
  margin-top: 3px;
  
  .top {
    width: 13px;
    margin-bottom: 3px;
  }
  .bottom {
    width: 6px;
  }
  .top,
  .bottom {
    height: 2px;
    background-color: ${colors.placeholderText};
    border-radius: 10px;
  }
`;
